import { useState } from 'react'
import { useAlert } from 'react-alert'

import { resetConstrutos } from '../../../../main/usecases'

import { useOnChangeDetect, useModalBox } from '../../../contexts'
import { Button } from '../../../components'

const DeleteConstrutoModal = ({ cdTypeToService, cdConstruto }: any) => {
  const [loading, setLoading] = useState(false)
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const { setRefresh } = useOnChangeDetect()

  const handleDeleteCustomer = async (
    cdTypeToService: number,
    cdConstruto: number
  ) => {
    try {
      setLoading(true)
      await resetConstrutos({
        cdTypeToService: cdTypeToService,
        cdConstruto: cdConstruto
      }).load()
      modalClose(true)
      alert.show('Construto personalizado deletado com sucesso', {
        type: 'success',
        timeout: 4000
      })
      setRefresh((prev: any) => !prev)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao deletar o construto personalizado', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="delete-modal">
      <p>Deseja realmente deletar o construto personalizado?</p>
      <div>
        <Button
          disabled={loading}
          hasredButton
          onClick={() => handleDeleteCustomer(cdTypeToService, cdConstruto)}
        >
          Sim
        </Button>
        <Button hasSecodaryButton onClick={modalClose}>
          Não
        </Button>
      </div>
    </div>
  )
}

export default DeleteConstrutoModal
